import React, { useState } from 'react'
import { UiCol, UiRowContainer, UiSingleContainer, UiSingleRow } from "../../components/grid-container/GridContainer"
import UiTopInput from "../../components/form/UiTopInput"
import { UiButtonPrimary } from "../../components/form/UiButton"
import {
    UiContentWr,
    UiTopInputWr,
    UiTopInputHeading,
    UiContentCol,
    UiContentColWithSlider,
    UiColTitleWr,
    UiColTitle,
    UiViewAll,
    UiTabContentWr,
    UiTabContent
} from "../../components/common/UiPageElements"
import UiMainWrapper from "../../components/common/UiMainWrapper"
import TopHeader from "../../components/header/TopHeader"
import HomeSlider from "./HomeSlider"
import UiSharingContentBlock from "../../components/common/UiSharingContentBlock"
import UiShareEmailInput from "../../components/form/UiShareEmailInput"
import UiBrowseAllRewards from "../../components/common/UiBrowseAllRewards"
import Footer from "../../components/footer/Footer"
import UiTopSelect from "../../components/form/UiTopSelect"
import OurFavourites from "./OurFavourites"
import TrendingAcrossSherbet from "./TrendingAcrossSherbet"
import Memberships from "./Memberships"
import { GoalCard } from '../Sidebar/GoalCard'
import { PointsCard } from '../Sidebar/PointsCard'
import { RecentPoints } from '../Sidebar/RecentPoints'
import { WishList } from '../Sidebar/WishList'
import { UiProfileCard } from '../Sidebar/ProfileCard'
import { UiScrollNavWr, UiScrollNavItem } from "../../components/common/UiScrollToElements"
import UiHowSherbetWork from "../../components/common/UiHowSherbetWork"
import { UiSalesChainElement, UiSalesChainElementWr } from "../../components/common/UiSalesChainElements"
import MyCurrentCampaigns from "./MyCurrentCampaigns"
import { UiFullLoadingSpinner } from "../../components/common/UiLoadingSpinner"
import UiAlertBox from "../../components/common/UiAlertBox"
import BottomNavIcon from "../../../../styles/img/bottom-nav-icon.png"
import TodoIcon from "../../../../styles/img/todo-bottom-icon.png"
import RewardsIcon from "../../../../styles/img/rewards-bottom-icon.png"
import HelpIcon from "../../../../styles/img/help-icon.png"
import {UiBottomNavBar,UiBottomNavBarItem} from "../../components/common/UiBottomNavBar"



export default function HomePage(props) {

    return (
        <>
            <UiFullLoadingSpinner fullLoading={false} />
            {/* <UiAlertBox show={true}/> */}
            <UiMainWrapper>
                <TopHeader />
                <HomeSlider dots={true}
                    slidesToShow={2} />
                <UiContentWr>
                    <UiTopInputWr>
                        <UiSingleRow>
                            <UiCol lg="10">
                                <UiTopInputHeading heading="Can I earn from this?" />
                            </UiCol>
                        </UiSingleRow>
                        <UiSingleRow>
                            <UiCol lg="5" className="col-12 mb-3">
                                <UiTopInput label="Enter Your Unqiue Sales Referrence ID"
                                    placeholder="98432328hFGIDB" />
                            </UiCol>
                            <UiCol lg="5" className="col-12 mb-3">
                                <UiTopSelect label="Select option to participate" />
                            </UiCol>
                            <UiCol lg="2" className="col-12">
                                <UiButtonPrimary btnName="Check" size="70" />
                            </UiCol>
                        </UiSingleRow>
                    </UiTopInputWr>
                </UiContentWr>

                <UiContentWr>
                    <UiTabContentWr>
                        <UiRowContainer fluid="fluid">
                            <UiScrollNavWr>
                                <UiScrollNavItem hash="Lastest-campaigns" hashText="Latest campaigns" />
                                <UiScrollNavItem hash="To-do-list" hashText="To-do list" />
                                <UiScrollNavItem hash="Trending-vouchers" hashText="Today's trending vouchers" />
                            </UiScrollNavWr>
                        </UiRowContainer>
                    </UiTabContentWr>
                </UiContentWr>

                <UiContentWr>
                    <UiRowContainer fluid="fluid" >
                        <UiCol lg="12" xl="12">
                            <UiContentColWithSlider>
                                <UiColTitleWr id="Lastest-campaigns">
                                    <UiColTitle
                                        title="Latest campaigns "
                                        amount="10,442"
                                        subtitle="Recent Campaigns Available" />
                                    <UiViewAll className="sb-view-all-margin" />
                                </UiColTitleWr>

                                <MyCurrentCampaigns />

                            </UiContentColWithSlider>
                        </UiCol>
                    </UiRowContainer>
                </UiContentWr>

                <UiContentWr>
                    <UiRowContainer fluid="fluid" >                                    
                        <UiCol lg="12" xl="9" className="order-mobile-first">
                            <UiContentCol>
                                <UiSingleRow >
                                    <UiCol lg="6" className="order-mobile-last">
                                        <UiColTitleWr>
                                            <UiColTitle
                                                title="My latest successes"
                                                sales="10"
                                                verifying="2"
                                                subtitle="sales confirmed," />
                                        </UiColTitleWr>
                                        <UiSalesChainElementWr>
                                            <UiSalesChainElement isActive={true} salesStatus="Entry confirmed for sale" salesId="NR7107463" date="22 Nov 2022" />
                                            <UiSalesChainElement isActive={true} salesStatus="Entry confirmed for sale" salesId="NR7107463" date="22 Nov 2022" />
                                            <UiSalesChainElement salesStatus="Verifying Entry for sale" salesId="NR7107463" date="22 Nov 2022" />
                                            <UiSalesChainElement salesStatus="Verifying Entry for sale" salesId="NR7107463" date="22 Nov 2022" />
                                        </UiSalesChainElementWr>
                                    </UiCol>
                                    <UiCol lg="6" className="order-mobile-first">
                                        <UiColTitleWr id="To-do-list">
                                            <UiColTitle
                                                title="To-do list"
                                                subtitle="Stay ahead to win more" />
                                            <UiViewAll />
                                        </UiColTitleWr>
                                        <UiSalesChainElementWr>
                                            <UiSalesChainElement isActive={true} salesStatus="You placed 1st! Won 12k points" salesId="NR7107463" date="22 Nov 2022" />
                                            <UiSalesChainElement salesStatus="Verifying Entry for sale" salesId="NR7107463" date="22 Nov 2022" />
                                            <UiSalesChainElement salesStatus="Verifying Entry for sale" salesId="NR7107463" date="22 Nov 2022" />
                                            <UiSalesChainElement salesStatus="Verifying Entry for sale" salesId="NR7107463" date="22 Nov 2022" />
                                        </UiSalesChainElementWr>
                                    </UiCol>
                                </UiSingleRow>
                            </UiContentCol>

                            <UiHowSherbetWork />
                            <UiContentCol>
                                <UiColTitleWr >
                                    <UiColTitle
                                        title="Recommended experiences"
                                        amount="10,442"
                                        subtitle="Carefully Selected Favourites" />
                                    <UiViewAll />
                                </UiColTitleWr>
                                <UiSingleRow className="mb-5">
                                    <OurFavourites />
                                </UiSingleRow>

                                <UiColTitleWr id="Trending-vouchers">
                                    <UiColTitle
                                        title="Trending vouchers"
                                        amount="7,404"
                                        subtitle="Trending Rewards" />
                                    <UiViewAll />
                                </UiColTitleWr>
                                <UiSingleRow>
                                    <TrendingAcrossSherbet />
                                </UiSingleRow>
                            </UiContentCol>
                        </UiCol>
                        <UiCol lg="6" xl="3" className="sb-sidebar-col order-mobile-last">
                            <UiContentCol>
                                {/* <UiProfileCard /> */}
                                <RecentPoints />
                                <PointsCard />
                                <WishList />
                                <GoalCard />
                            </UiContentCol>
                        </UiCol>
                    </UiRowContainer>
                    <UiRowContainer fluid="fluid" >
                        <UiCol lg="12" className="mt-4">
                            <UiContentCol>
                                <UiColTitleWr>
                                    <UiColTitle
                                        title="Buy: Memberships"
                                        subtitle="You deserve it, use it with Sherbet" />
                                    <UiViewAll className="sb-view-all-margin" />
                                </UiColTitleWr>
                                <UiSingleRow className="sb-mob-flex mt-4">
                                    <Memberships />
                                </UiSingleRow>
                            </UiContentCol>
                        </UiCol>
                        <UiCol lg="12" className="mt-4">
                            <UiSharingContentBlock>
                                <UiShareEmailInput placeholder="Add their email here" />
                                <UiButtonPrimary btnName="Go" size="55" />
                            </UiSharingContentBlock>
                        </UiCol>
                        <UiCol lg="12" className="mt-4">
                            <UiBrowseAllRewards />
                        </UiCol>
                    </UiRowContainer>
                </UiContentWr>
                <Footer />
                <UiBottomNavBar >
                    <UiBottomNavBarItem navIcon={BottomNavIcon} navTitle="Campaigns" />
                    <UiBottomNavBarItem navIcon={TodoIcon} navTitle="To Do" />
                    <UiBottomNavBarItem navIcon={RewardsIcon} navTitle="Rewards" />
                    <UiBottomNavBarItem navIcon={HelpIcon} navTitle="Help" />
                </UiBottomNavBar>
                   

            </UiMainWrapper>
        </>
    )
}



